import {
  formatDate,
  differentDayStrings,
} from 'ui-component-library/utils/helpers'

const DATE_FORMAT = 'MMMM d, yyyy'

export default function fullDate(startDate: string, endDate: string) {
  if (differentDayStrings(startDate, endDate)) {
    return `${formatDate(startDate, 'MMMM d')} - ${formatDate(
      endDate,
      DATE_FORMAT,
    )}`
  } else {
    return formatDate(startDate, DATE_FORMAT)
  }
}
